export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/mju_likelion/',
  github: 'https://github.com/mju-likelion',
  facebook: 'https://www.facebook.com/likelionatmju',
  medium: 'https://medium.com/@mju-likelion',
  email: 'mju@likelion.org',
};
